export const stringToArray = (value: string | string[]): string[] => {
  if (typeof value === 'string') {
    return [value];
  }
  return value;
};
